var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15836 0.82918C9.41245 0.321004 9.93184 0 10.5 0H13.5C14.0682 0 14.5876 0.321004 14.8416 0.82918L15.9271 3H20C20.8284 3 21.5 3.67157 21.5 4.5C21.5 5.32843 20.8284 6 20 6V21C20 22.6569 18.6569 24 17 24H7C5.34315 24 4 22.6569 4 21L4 6C3.17157 6 2.5 5.32843 2.5 4.5C2.5 3.67157 3.17157 3 4 3H8.07295L9.15836 0.82918ZM8 8C8 7.44771 8.44772 7 9 7C9.55228 7 10 7.44772 10 8V19C10 19.5523 9.55228 20 9 20C8.44772 20 8 19.5523 8 19V8ZM14 8C14 7.44771 14.4477 7 15 7C15.5523 7 16 7.44772 16 8V19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19V8Z",
    fill: "currentColor"
  })));
}

export default SvgTrash;